<template lang="pug">
v-dialog(
  v-model="switchDialog"
  persistent
  max-width="400")
  v-card.pa-10.modal.switch
    v-icon(@click="switchDialog=false") mdi-close
    v-card-text
      v-icon(size="60px") $warning
      h3.modal-heading {{ $t('label.switch.heading') }}
      p.modal-text {{ $t('label.switch.description') }}
      .btn-wrapper
        v-btn(id="logout_from_all_other_devices" depressed block @click="logOutFromAllOtherDevices")
          | {{ $t('action.switch.logout') }}
        v-btn(id="change_password" depressed block :to="{ name: 'password' }"  @click="switchDialog=false")
          | {{ $t('action.switch.changePasword') }}
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { LogoutRequests } from '@/services/http/logout-requests';

export default {

  name: 'AppSwitch',

  data() {
    return { };
  },

  computed: {
    ...mapGetters('Ui', ['getShowSwitchDialog']),

    switchDialog: {
      get() {
        return this.getShowSwitchDialog;
      },
      set(value) {
        this.$store.dispatch('Ui/setSwitchStatus', value);
      },
    },
  },

  methods: {
    ...mapActions('Ui', ['setSwitchStatus']),
    logOutFromAllOtherDevices() {
      LogoutRequests.logoutAll();
      this.switchDialog = false;
      this.$notify.success(this.$t('label.switch.success_logout'));
    },
  },

};
</script>

<style lang="scss" scoped>
.switch{
  position: relative;
  .mdi-close{
    position: absolute;
    right: 40px;
    top: 36px;
  }
  .modal-heading{
    margin: 24px 0 10px !important;
  }
  .modal-text{
    color: #4B4B4B;
    font-size: 14px;
    font-weight: 400;
    line-height:  24.5px;
  }
  .btn-wrapper{
    display: flex;
    flex-direction: column;
    gap: 16px;

    .v-btn{
      height: 48px;
      border-radius: 10px !important;
      background: #06BDE9;
      color: white;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: normal;
      &:last-child{
        background: #EFEFEF !important;
        color: #4B4B4B !important;
      }
      &:hover::before,&::before{
        opacity: 0 !important;
      }
    }
    // .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before{
    //   opacity: 0 !important;
    // }
  }
  .v-card__text{
    padding: 10px 0 0 0;
    text-align: center;
  }

}

</style>
